module.exports = __webpack_public_path__ + "static/media/1POLICY11.7dd7cdd4.jpg";